import React, { Component } from 'react';
import { connect } from 'react-redux';
import InputMask from 'react-input-mask';
import { momentumActions } from '../../../../_actions';
import { Loader } from '../../../../_components';
import { SimpleFetch, store } from '../../../../_helpers';
import moment from 'moment';
import Select from 'react-select';
import AsyncCreatableSelect from 'react-select/async-creatable'
import DatePicker, { registerLocale } from 'react-datepicker';
import ptBR from 'date-fns/locale/pt-BR';
registerLocale('pt-BR', ptBR);
moment().locale('pt-br');

class FilterBlock extends Component {
  constructor(props) {
    super(props);

    this.state = {
      filters: [],
      filterSelected: false,
      filtersListed: false,
      filter: {},
      selectValue: '0',
      regularExpression: false,
      value: '',
      customFilters: [],
      customFilterType: '',
      loadedFilter: true,
      filterValue: "0",
      tooltipIsOpen: false,
      updatedFilters: null,
      multiSelectValues: "",
      singleSelectValue: "",
      multiFilterValue: [],
      silgleFilterValue: [],
      openNewFilter: false,
      viewMode: false
    }

    this.customToolip = React.createRef();

    this.handleChange = this.handleChange.bind(this);
    this.handleFilterValue = this.handleFilterValue.bind(this);
    this.handleChangeSelect = this.handleChangeSelect.bind(this);
    this.handleChangeRegularExpression = this.handleChangeRegularExpression.bind(this);
    this.updateFiltersListing = this.updateFiltersListing.bind(this);
    this.handleMultiSelect = this.handleMultiSelect.bind(this);
    this.handleSingleSelect = this.handleSingleSelect.bind(this);
    this.editingFilter = this.editingFilter.bind(this);
    this.editingCustomSelect = this.editingCustomSelect.bind(this);
    this.handleNewFilterBlock = this.handleNewFilterBlock.bind(this);
    this.handleNewBlockClick = this.handleNewBlockClick.bind(this);
    this.handleUpdateFilters = this.handleUpdateFilters.bind(this);
  }

  componentDidMount() {
    if ( sessionStorage.getItem('cellit_available_filters') ) {
      let filters = JSON.parse(sessionStorage.getItem('cellit_available_filters')).data;
      this.setState({filtersListed: true, filters});
    }

    const cardData = this.props.cardData
    const { dispatch } = this.props;

    if (cardData) {
      this.setState({
        loadedFilter: false
      });

      dispatch(momentumActions.listCustomFilters(JSON.parse(sessionStorage.getItem('selected_domain')).uuid, cardData.values[0].filter))
      .then(res => {
        const arrValues = cardData.values[0].value ? cardData.values[0].value.split(',') : [];
        let multiFilterArr;


        this.setState({
          loadedFilter: true,
          customFilters: res.message.data,
          selectValue: cardData.values[0].comparation,
          singleSelectValue: cardData.values[0].value,
          multiSelectValues: arrValues,
          updatedFilters: res.data,
          filterValue: cardData.values[0].filter,
          value: cardData.values[0].value,
          regularExpression: cardData.regex,
          multiFilterValue: multiFilterArr,
        });

        this.editingFilter(cardData.values[0].filter)
      });
    }

    if (this.props.viewMode) return this.setState({viewMode: true});

    this.setState({multipleFilters: this.props.multipleFilters});
  }
  
  componentWillReceiveProps(newProps) {
    this.setState({multipleFilters: newProps.multipleFilters});
  }

  handleChangeRegularExpression(e) {
    this.setState({regularExpression: e.target.checked});
  }

  handleChangeSelect(e) {
    this.setState({selectValue: e.target.value});
  }

  handleChange(e) {
    e.preventDefault();
    let state = {filterSelected: true};

    this.setState({
      filterValue: e.target.value,
      multiFilterValue: '',
      singleSelectValue: '',
      multiSelectValue: '',
      changedFilter: true
    });

    if (e.target.value == 0) {
      state.filterSelected = false;
      state.filter = { type : null };
      this.setState(state);
      return;
    }

    let filter = this.state.filters.filter((filter, index) => {
      return filter.key === e.target.value;
    });

    if (filter) {
      state.filter = filter[0]
      if (!state.filter.mask) {
        state.filter.mask = '****************************************************************************************************';
      } else {
        state.filter.mask = state.filter.mask;
      }
    }

    this.setState(state);

    this.setState({
      value: '',
      loadedFilter: false
    });

    const key = e.target.value;

    this.editingFilter(key)
  }

  editingFilter(key) {
    switch (key) {
      case 'user_stored_data.navigator.browser':
        this.callCustomFilter(key);
        break;
      case 'user_stored_data.visited.url':
        this.callCustomFilter(key);
        break;
      case 'user_stored_data.client.device.os':
        this.callCustomFilter(key);
        break;
      case 'user_stored_data.origin':
        this.callCustomFilter(key, 'origin');
        break; 
      case 'user_stored_data.client.location.country':
        this.callCustomFilter(key, 'country');
        break;
      case 'user_stored_data.navigator.version':
        this.callCustomFilter(key);
        break;
      case 'user_stored_data.client.location.city':
        this.callCustomFilter(key);
        break;
      case 'user_stored_data.client.location.region':
        this.callCustomFilter(key, 'region');
        break;
      case 'user_stored_data.client.device.name':
        this.callCustomFilter(key);
        break;
      case 'user_stored_data.navigator.mobile':
        this.callCustomFilter(key, 'mobile');
        break;
      case 'user_stored_data.asn.autonomous_system_organization':
        this.callCustomFilter(key);
        break;
      case 'user_stored_data.navigator.language':
        this.callCustomFilter(key);
        break;
      case 'user_stored_data.notified.clicked':
        this.callCustomFilter(key, 'momentum');
        break;
      case 'user_stored_data.notified.viewed':
        this.callCustomFilter(key, 'momentum');
        break;
      case 'user_stored_data.notified.momentum_uuid':
        this.callCustomFilter(key, 'momentum');
        break;
      default:
        this.setState({
          customFilters: [],
          loadedFilter: true
        });
        break;
    }
  }

  editingCustomSelect(key, opt, selected) {
    const { dispatch } = this.props;

    let customSelect = [];

    dispatch(momentumActions.listCustomFilters(JSON.parse(sessionStorage.getItem('selected_domain')).uuid, key))
      .then(res => {
        let data = res.message.data;

        if ( opt === "country" ) {
          selected.forEach(elementSelected => {
            data.forEach(element=> {
              if (elementSelected === element.code) {
                customSelect.push({
                  value: element.code,
                  label: element.emoji + ' ' + element.name
                })
              }
            })
          });
        }

        if ( opt === "region" ) {
          selected.forEach(elementSelected => {
            data.forEach(element=> {
              if (elementSelected === element.initials) {
                customSelect.push({
                  value: element.initials,
                  label: element.state
                })
              }
            })
          });
        }
    });

    return customSelect;
  }

  callCustomFilter(key, opt) {
    const { dispatch } = this.props;

    if ( opt === "mobile" ) {
      this.updateFiltersListing(null, opt);
      return this.setState({loadedFilter: true, customFilters: [{a: "b"}]});
    }

    dispatch(momentumActions.listCustomFilters(JSON.parse(sessionStorage.getItem('selected_domain')).uuid, key))
      .then(res => {
        if ( opt ) {
          this.updateFiltersListing(res.message.data, opt);
          return this.setState({
            customFilters: res.message.data,
            customFilterType: opt,
            loadedFilter: true
          })
        }

        this.updateFiltersListing(res.message.data, 'normal');
        this.setState({
          customFilters: res.message.data,
          customFilterType: 'normal',
          loadedFilter: true
        });
      });
  }

  handleFilterValue(e) {
    this.setState({
      value: e.target.value
    });
  }

  onChange = (event) => {
    this.setState({
      value: event.target.value
    });
  }

  updateFiltersListing(data, opt) {
    let updatedFilters = new Array();

    if ( opt === "mobile" ) {
      updatedFilters.push(
        { value: true, label: "Sim" },
        { value: false, label: "Não" }
      )
  
      return this.setState({updatedFilters});
    }

    data.map((item, index) => {
      if ( !item || !item.name || !item.value ) return;

      let value = item.value;
      let label = item.name;
      
      if ( opt === "country" )
        label = `${item.emoji} ${item.name}`;

      updatedFilters.push({value, label});
    });

    this.setState({updatedFilters});
  }

  async handleUpdateFilters(e) {
    const res = await SimpleFetch(`GET`, {}, {}, `momentum`, `person/search/${store.getState().changeDomainReducer.selectedDomain.domain_uuid}/filter/${this.state.filterValue}?search=${e}`);
    if ( !res ) return

    let updatedFilters = new Array();
    res.data.map((item, index) => {
      if ( !item || !item.name || !item.value ) return;

      let value = item.value;
      let label = item.name;

      updatedFilters.push({value, label});
    });

    this.setState({updatedFilters})
    return updatedFilters
  }

  async handleMultiSelect(e) {
    let arr = new Array();

    if ( !e ) return;

    e.map(item => {
      arr.push(item.value);
    });

    arr.sort((a, b) => a - b);

    this.setState({multiSelectValues: arr, multiFilterValue: e});
  }

  handleSingleSelect(e) {
    if (this.state.customFilterType === 'mobile')
      this.props.handleMobileSelect(e.value)

    this.setState({singleSelectValue: e.value});
  }

  handleNewFilterBlock(e) {
    let openNewFilter = (e.type === "mouseleave") ? false : true;
    this.setState({openNewFilter});
  }

  handleNewBlockClick(e) {
    this.props.handleBlockAdd(e);
  }

  hadleRemoveClick = e => {
    let closestChild = e.target.parentNode;
    closestChild.parentNode.removeChild(closestChild);

    this.props.handleBlockRemove(e);
  }

  render() {
    const { tooltipIsOpen } = this.state;
    const style = this.state.filter.type === "fixed" || this.state.filter.type === "custom"? {display: 'none'} : {};

    return(
      <>
        <input type="hidden" name="filter-type" id="filter-type" defaultValue="filter"/>

        <div className="block filter-block filter-block-component">
          <div className="custom-tooltip">
            <a href="#" className={`custom-tooltip-link ${tooltipIsOpen ? 'active' : ''}`} onClick={() => tooltipIsOpen ? this.setState({tooltipIsOpen: false}) : this.setState({tooltipIsOpen: true})}>
              <span>?</span>
              
              <div className="custom-tooltip-card">
                <p>Filtrar para quem será enviado as notificações. Exemplo: pode ser por país, cidade ou para toda a Base.</p>
              </div>
            </a>
          </div>

          <p className="block-title">Filtro</p>
          <div className="select-group">
            <select name="filter-filter" id="filter-filter" className="form-control" onChange={this.handleChange} required value={this.state.filterValue} disabled={this.state.viewMode}>
              <option value="0" disabled>Selecione uma opção</option>
              {
                this.state.filters && this.state.filters.length !== 0 ?
                  this.state.filters.map((filter, index) => {
                    if ( typeof(filter.name) === "object" ) return
                    return <option key={`${index}-${filter.key}`} value={filter.key}>{filter.name}</option>
                  })
                : "Algo deu errado. Tente novamente mais tarde"
              }
            </select>
          </div>

          <br/>
         
          {
            this.state.filterValue !== "0" && this.state.filterValue !== "all" ?
              <div className='filter-group active'>
                <p className="block-title">Filtrar por:</p>
                {
                  this.state.loadedFilter ? 
                    this.state.customFilters.length ? 
                      <div>
                        {
                          this.state.customFilters ?
                            this.state.customFilterType === 'mobile' ?
                              <>
                                <input type="hidden" id="filter-value" name="filter-value" value={this.state.singleSelectValue}/>
                                <div className="select-group">
                                  <select name="filter-comparation" id="filter-comparation" className="form-control active" value={this.state.selectValue} onChange={this.handleChangeSelect} required disabled={this.state.viewMode}style={{marginBottom: "15px"}} >
                                    <option value="0" disabled>Selecione uma opção</option>
                                    <option value="==">Igual a</option>
                                    <option value="!=">Diferente de</option>
                                    <option value="contain">Contém</option>
                                    <option value="notcontain">Não contém</option>
                                  </select>
                                </div>
                                <Select
                                  options={this.state.updatedFilters}
                                  className="basic-select"
                                  classNamePrefix="select"
                                  placeholder="Selecione o valor"
                                  onChange={this.handleSingleSelect}
                                  isDisabled={this.state.viewMode}
                                />
                              </>
                            : <>
                              <input type="hidden" id="filter-value" name="filter-value" value={this.state.multiSelectValues}/>
                              <div className="select-group">
                                <select name="filter-comparation" id="filter-comparation" className="form-control active" value={this.state.selectValue} onChange={this.handleChangeSelect} required disabled={this.state.viewMode} style={{marginBottom: "15px"}}>
                                  <option value="0" disabled>Selecione uma opção</option>
                                  <option value="==">Igual a</option>
                                  <option value="!=">Diferente de</option>
                                  <option value="contain">Contém</option>
                                  <option value="notcontain">Não contém</option>
                                </select>
                              </div>
                              <AsyncCreatableSelect
                                className="basic-multi-select"
                                isClearable
                                isMulti
                                cacheOptions
                                onChange={(e) => this.handleMultiSelect(e)}
                                placeholder="Selecione os valores"
                                isDisabled={this.state.viewMode}
                                defaultOptions={this.state.updatedFilters}
                                loadOptions={this.handleUpdateFilters}
                              />
                            </>
                          : null
                        }
                      </div> :
                        this.state.filterValue !== 'user_stored_data.createdAt' ?
                          <DefaultFormOptions evt={this} />
                        : <DefaultDateOptions evt={this} />
                  : <Loader className="relative" />
                }
              </div>
            : null
          }

          <div className={`btn btn-white btn-block-add-more ${this.state.openNewFilter ? "active" : ""}`} onMouseLeave={this.handleNewFilterBlock} onClick={this.handleNewFilterBlock} style={{display: "none"}}>
            <i className="linearicons-plus"></i>

            <span className="btn-tooltip is-black">
              Adicionar nova condição
            </span>

            <span className="btn-inner-group">
              <a href="#" data-block="Filter" onClick={this.handleNewBlockClick}>E</a>
              <span className="spacer"></span>
              <a href="#" data-block="Filter" onClick={this.handleNewBlockClick}>OU</a>
            </span>
          </div>

          {
            this.state.multipleFilters > 1 ? 
              <div className={`btn btn-white btn-block-remove`} onClick={this.hadleRemoveClick} >
                <i className="linearicons-cross"></i>

                <span className="btn-tooltip is-black">
                  Remover condição
                </span>
              </div>
            : ''
          }
            
        </div>
      </>
    )
  }
}

class DefaultFormOptions extends Component {
  constructor(props) {
    super(props);
    
    this.state = {
      selected: false
    }
  }

  render() {
    return (
      <div className='filter-group active'>
        <div className="select-group">
          <select name="filter-comparation" id="filter-comparation" className="form-control active" value={this.props.evt.state.selectValue} onChange={this.props.evt.handleChangeSelect} required disabled={this.props.evt.state.viewMode}>
            <option value="0" disabled>Selecione uma opção</option>
            <option value="==">Igual a</option>
            <option value="!=">Diferente de</option>
            <option value="<">Menor que</option>
            <option value="<=">Menor que ou igual a</option>
            <option value=">">Maior que</option>
            <option value=">=">Maior que ou igual a</option>
            <option value="contain">Contém</option>
            <option value="notcontain">Não contém</option>
            <option value="exactly">Corresponde exatamente</option>
          </select>
        </div>

        <input type="text" name="filter-value" id="filter-value" className="form-control" value={this.props.evt.state.value} onChange={this.props.evt.onChange} placeholder="Valor" required readOnly={this.props.evt.state.viewMode}/>
      </div>
    )
  }
}

class DefaultDateOptions extends Component {
  constructor(props) {
    super(props);

    this.state = {
      selected: 0,
      date: moment().toDate(),
      dateFormatted: null,
      dateToDB: moment().toISOString(),
      startDate: moment().toDate(),
      startDateFormatted: null,
      endDate: null,
      endDateFormatted: null
    }

    this.handleSelection = this.handleSelection.bind(this);
    this.handleChange = this.handleChange.bind(this);
    this.handleChangeStart = this.handleChangeStart.bind(this);
    this.handleChangeEnd = this.handleChangeEnd.bind(this);
  }

  componentDidMount() {
    const editData = this.props.evt.props.cardData;

    if (editData && !this.props.evt.state.changedFilter) {
      if (editData.values[0].value2) {
        this.setState({
          selected: editData.values[0].comparation,
          startDate: moment(editData.values[0].value).toDate(),
          startDateFormatted: moment(editData.values[0].value).toDate(),
          startDateToDB: moment(editData.values[0].value).toISOString(),
          endDate: moment(editData.values[0].value2).toDate(),
          endDateFormatted: moment(editData.values[0].value2).toDate(),
          endDateToDB: moment(editData.values[0].value2).toISOString()
        });
      } else {
        this.setState({
          selected: editData.values[0].comparation,
          date: moment(editData.values[0].value).toDate(),
          dateFormatted: moment(editData.values[0].value).toDate(),
          dateToDB: moment(editData.values[0].value).toISOString()
        });
      }
    }
  }

  handleSelection(e) {
    this.setState({selected: e.target.value})
  }
  
  handleChange(e) {
    this.setState({
      date: e,
      dateToDB: moment(e).toISOString(),
      dateFormatted: moment(e).toDate(),
    })
  }

  handleChangeStart(e) {
    this.setState({
      startDate: e,
      startDateToDB: moment(e).toISOString(),
      startDateFormatted: moment(e).toDate()
    })
  }

  handleChangeEnd(e) {
    this.setState({
      endDate: e,
      endDateToDB: moment(e).toISOString(),
      endDateFormatted: moment(e).toDate()
    })
  }

  render() {
    return (
      <div className='filter-group active'>
        <div className="select-group">
          <select name="filter-comparation" id="filter-comparation" className="form-control active" value={this.state.selected} onChange={this.handleSelection} required disabled={this.props.evt.state.viewMode}>
            <option value="0" disabled>Selecione uma opção</option>
            <option value="<">Antes de</option>
            <option value=">">Depois de</option>
            <option value="between">Entre</option>
          </select>
        </div>

        {
          this.state.selected !== 0 ?
            this.state.selected !== "between" ?
              <>
                <input type="hidden" name="filter-value" id="filter-value" className="form-control" value={this.state.dateToDB} />
                <DatePicker
                  className="form-control"
                  locale="pt-BR"
                  name="datepicker-value"
                  id="datepicker-value"
                  selected={this.state.date}
                  onChange={this.handleChange}
                  value={this.state.dateFormatted}
                  timeInputLabel="Horário"
                  dateFormat="dd/MM/yyyy HH:mm"
                  placeholderText="Defina o dia e hora"
                  showTimeInput
                  popperPlacement="bottom"
                  disabled={this.props.evt.state.viewMode}
                  popperModifiers={{
                    flip: {behavior: ["bottom"]},
                    offset: {enabled: true, offset: '20px, 5px'},
                    preventOverflow: {enabled: false},
                    hide: {enabled: false}
                  }}
                />
              </>
            : <span>
              <input type="hidden" name="filter-value" id="filter-value" className="form-control" value={this.state.startDateToDB} />
                <DatePicker
                  className="form-control"
                  locale="pt-BR"
                  name="datepicker-value"
                  id="datepicker-value"
                  selected={this.state.startDate}
                  onChange={this.handleChangeStart}
                  startDate={this.state.startDate}
                  endDate={this.state.endDate}
                  timeInputLabel="Horário"
                  dateFormat="dd/MM/yyyy HH:mm"
                  placeholderText="Data inicial"
                  value={this.state.startDateFormatted}
                  selectsStart
                  showTimeInput
                  popperPlacement="bottom"
                  disabled={this.props.evt.state.viewMode}
                  popperModifiers={{
                    flip: {behavior: ["bottom"]},
                    offset: {enabled: true, offset: '20px, 5px'},
                    preventOverflow: {enabled: false},
                    hide: {enabled: false}
                  }}
                />
                <input type="hidden" name="filter-value2" id="filter-value2" className="form-control" value={this.state.endDateToDB} />
                <DatePicker
                  className="form-control"
                  locale="pt-BR"
                  name="datepicker-value2"
                  id="datepicker-value2"
                  selected={this.state.endDate}
                  onChange={this.handleChangeEnd}
                  timeInputLabel="Horário"
                  dateFormat="dd/MM/yyyy HH:mm"
                  placeholderText="Data final"
                  startDate={this.state.startDate}
                  endDate={this.state.endDate}
                  value={this.state.endDateFormatted}
                  selectsEnd
                  showTimeInput
                  disabled={this.props.evt.state.viewMode}
                  popperPlacement="bottom"
                  popperModifiers={{
                    flip: {behavior: ["bottom"]},
                    offset: {enabled: true, offset: '20px, 5px'},
                    preventOverflow: {enabled: false},
                    hide: {enabled: false}
                  }}
                />
              </span>
          : null
        }
      </div>
    )
  }
}

function mapStateToProps(state) {
  const { listedFilters } = state.listFiltersReducer;
  return listedFilters;
}

const ConnectedFilterBlock = connect(mapStateToProps)(FilterBlock);
export { ConnectedFilterBlock as Filter }